<template>
     <div class="energy-flow">
      
        <div class="con">
            <div class="tree-left">
                <div class="search">
                   <el-input placeholder="输入关键字进行过滤节点" v-model="filterText"></el-input>
                </div>
                <div style="margin-bottom:12px;width:100%">
                  <el-select v-model="typeVal" clearable placeholder="筛选类型" style="width:100%" @change="type_fn">
                      <el-option
                        v-for="item in typeoptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                </div>

                   <div class="btns">
                       <span v-show="false">{{unitId}}</span>
                  <el-button type="primary" size="mini"  @click="popupFn('add')">新增子级</el-button>
                  <el-button type="primary" size="mini"  @click="popupFn('eait')">修改</el-button>
                  <el-button type="danger" size="mini"  @click="delFun">删除</el-button>
               </div>
               <!-- <div class="tree-con" style="padding-left:10px"> -->
                   <div class="scroll" style="width:100%;height:84%">
			             <el-scrollbar style="height:98%;width: 100%;">
                           <el-tree
                              :data="leftData"
                              :props="defaultProps1"
                              ref="leftTree"
                              @node-click="leftTreeClick"
                              :highlight-current="true"
                              :expand-on-click-node="true" 
                               node-key="id"
                             :default-expanded-keys="defaultExpanded" 
			                    :current-node-key='defaultDevice'
                              >
                              <!-- node-key="id" -->
                              <!-- default-expand-all (默认展开所有) -->
                              <span class="custom-tree-node" slot-scope="{node}" style="display: flex;align-items: center;">
                                 <!-- <span v-show="true">{{node}}</span> -->
                                                   <img src="../../../public/static/image/elTree/1.9.png" style="margin-right: 5px;" v-show="node.data.tag == 1"/>
                                                   <img src="../../../public/static/image/elTree/group.png" style="margin-right: 5px;" v-show="node.data.tag != 1"/>
                                                   <!-- <img src="../../../../public/static/image/elTree/2.5.png" style="margin-right: 5px; position: relative;top: 3px;" v-show="data.dataType == 1"/> -->
                                       <span style="padding-left: 5px;" >{{node.data.unitName}}</span>
                                       </span>
                           </el-tree>
                     	</el-scrollbar>
		               </div>
                  <!-- </div> -->
                  
            </div>
            <div class="content">
               <div class="Files-top ">
						<div class="ic-left content-title">
						<span>节点设备列表<span style="color:#000;font-size:16px" v-show="nodeItem.unitName">/ {{nodeItem.unitName}}</span></span>
						</div>
						<div class="btns">
						 <!-- <el-button  @click="exportExcel" type="primary" class="last-el-button">导出</el-button> -->
						</div>
					</div>
               <div style="display: flex;">
                  <div class="mytable">
                     <el-table
                        ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        :max-height="heights"
                        border
                        @selection-change="handleSelectionChange">
                       <template slot="empty">
                <span class="noData">
                  <img src="@/assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
                        <el-table-column
                           type="selection"
                           width="44" align="center">
                        </el-table-column>
                         <el-table-column  width="90" label="序号" align="center">
                           <template slot-scope="scope">
                              <span>{{ scope.$index + 1 }}</span>
                           </template>
                           </el-table-column>
                        <el-table-column
                           label="设备号"
                           width="180">
                           <template slot-scope="scope">{{ scope.row.deviceNo }}</template>
                        </el-table-column>
                        <el-table-column
                           prop="deviceName"
                           label="设备名称"
                           >
                        </el-table-column>

                     </el-table>

                  </div>
                  <!-- <img src="../../assets/left.png" alt=""> -->
                  <!-- <div class="conten-btns">
                     <el-button type="primary"  size="medium" icon="el-icon-arrow-left"   @click="device_Add">添加</el-button>
                     <br>
                     <el-button type="warning"  size="medium"   @click="device_Del">删除<i class="el-icon-arrow-right el-icon--right"></i></el-button>
                  </div> -->
                    <div class="conten-btns">
                     <div class="left-add" @click="device_Add">添加<img src="../../assets/left.png" alt=""></div>
                     <div class="del-btn-transfer" @click="device_Del">移除<img src="../../assets/right.png" alt=""></div>
                  </div>
               </div>
            </div>
            <div class="tree-right">
                 <div class="search">
                   <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                </div>
                <!-- <div class="right-tree" style="padding-left:10px"> -->
                   <div class="scroll" style="width:100%;height:93%">
			             <el-scrollbar style="height:100%;width: 100%;">
                  <el-tree
                     :data="rightData"
                     show-checkbox
                     node-key="numNo"
                     :props="defaultProps"
                     @check="currentChecked"
                     ref="tree"
                     >
                      <span class="custom-tree-node" slot-scope="{node}">
                         <img src="../../../public/static/image/elTree/1.9.png" style="margin-right: 5px;" v-show="node.data.Content.Category=='Organization'"/>
                         <img src="../../../public/static/image/elTree/2.1.png" style="margin-right: 5px;" v-show="node.data.Content.Category=='Device'"/>
                        	<span style="padding-left: 5px;" >{{node.data.Content.Name}}</span>
                        </span>
                  </el-tree>
                  </el-scrollbar>
		               </div>
                  <!-- </div> -->
            </div>
        </div>

        <!-- 新增修改 -->
    <!-- <el-dialog v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false' :visible.sync="dialogVisible" -->
    <el-dialog v-dialogDrag :title="dialogStatus + ' ('+ unitItem.unitName +' )'" :close-on-click-modal='false' :visible.sync="dialogVisible"
      width="200" center>
      <el-form :model="temp" :rules="rules" ref="temp" label-width="120px" class="demo-temp">
        <el-form-item label="名称:" prop="name" v-show="dialogStatus == '新增'">
          <el-input v-model="temp.name" @input="forceUpdate"></el-input>
        </el-form-item>
        <el-form-item label="旧名称:"  v-show="dialogStatus != '新增'">
          <el-input v-model="oldName" disabled></el-input>
        </el-form-item>
        <el-form-item label="新名称:" prop="name" v-show="dialogStatus != '新增'">
          <el-input v-model="temp.name" @input="forceUpdate"></el-input>
        </el-form-item>
        <el-form-item label="图形类型:" prop="code" v-show="tag==1">
            <el-radio v-model="radio" label="能流分析">能流分析</el-radio>
            <el-radio v-model="radio" label="变损分析">变损分析</el-radio>
            <el-radio v-model="radio" label="线损分析">线损分析</el-radio>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <!-- <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">确 定 -->
          <el-button type="primary" @click="determine_Fn(dialogStatus)">确 定
          </el-button>
        </span>
      </template>
    </el-dialog>
     </div>
</template>

<script>
import {findUnitInfo,diagramSave,diagramNodeSave,diagramDelete,diagramNodeDelete,getDeviceByNodeId,diagramDeviceSave,diagramDeviceDelete} from "../../api/energyFlow";
import {getReadDeviceTree} from "../../api/abbNewApi";
// import elRadioTree from '@/components/module/tree/elRadioTree.vue'
export default {
    data(){
      return {
        typeVal:"",
        typeoptions:[{
          value: '能流分析',
          label: '能流分析'
        },{
          value: '变损分析',
          label: '变损分析'
        },{
          value: '线损分析',
          label: '线损分析'
        }],
          heights: document.getElementById('app').clientHeight-200,
         dialogStatus:"新增",//弹窗类型
         radio:"能流分析",//单选框
         
        leftData:[],//左边树形结构数据
        rightData:[],//右边树形结构树形
        defaultProps1: {
          children: 'children',
          label: 'unitName'
        },
        defaultProps: {
          children: 'ChildDatas',
          label: 'Content.Name'
        },
         filterText: '',
         tableData: [],
        multipleSelection: [],
         rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' }
          ],
        },
        temp: {},
         dialogVisible: false,
         unitItem:[],
         tag:1,//判断点击的是单位/能流图/节点
         nodeItem:[],//节点
        checkedNodes:[],
				halfCheckedNodes:null,
            nowNode:"",
            defaultExpanded:[],
				defaultDevice:"",
        leftDataCopy:[],
        oldName:""
      }
    },
     watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
        unitId(){
           this.findUnitInfoFun()
        }
      
    },
     computed:{
        unitId(){
          return this.$store.unitStore.state.nowUnit
        }
      },
    mounted(){
      this.findUnitInfoFun()
        var num = 0
      getReadDeviceTree().then(res => {
        // console.log("设备列表",res);
        var recursiveFunction = function(){
							const getStr = function(list){
								list.forEach(function(row){
									if(row.ChildDatas.length != 0){
										// console.log("row.ChildDatas",row);
                    row.numNo = num++
										getStr(row.ChildDatas)
									}else {
										// console.log("row.ChildDatas1234",row.Content.Name);
                    row.numNo = num++
                    row['disabled'] = false
										// str += row.Content.Name + ";"
										// row.ChildDatas = row.Content.groups
									}
								})
							}
							getStr(res.data)
						}
						recursiveFunction()
        this.rightData = res.data
      })
    },
    beforeDestroy(){
      this.nodeItem = []
    },
    methods: {
      type_fn(val){
        console.log("val",val);
        var data = this.leftDataCopy[0].children.filter(item => item.appType==val)
        console.log("data",data);
        if(val == ""){
          this.leftData[0].children = this.leftDataCopy[0].children

          }else {
          this.leftData[0].children = data
           
        }
      },
      forceUpdate() {
          this.$forceUpdate()
      },
      //左边树形结构筛选
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      //表格全选反选
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //左边树形结构数据
      findUnitInfoFun(){
          var d =  {
          unitId:this.unitId.id
        }
         findUnitInfo(d).then(res => {
            res.data =  JSON.parse(JSON.stringify(res.data).replace(/name/g, 'unitName'))
            
            var list = [res.data]
            list[0].id =  list[0].unitId
            this.leftData = list
            this.leftDataCopy = JSON.parse(JSON.stringify(list))
            this.defaultDevice = this.unitItem.id
            this.defaultExpanded.push(this.unitItem.id)
            this.$nextTick(()=>{
              //默认选中
              this.$refs['leftTree'].setCurrentKey(this.defaultDevice);
            })
         })
      },
      //左边数据结构点击
      leftTreeClick(item){
         this.unitItem = item
           //tag==1 点击了单位，所以是添加能流图
           //tag==2 点击了能流图，所以是添加节点
           //tag==3 点击了能流图的节点，所以是添加节点中的子节点
         this.tag = item.tag
         this.oldName = item.unitName
        //  console.log("this.tag",this.tag);
         if(this.tag == 3){
            this.nodeItem = item
            this.getDeviceList(item.id)
         }else {
            this.tableData  = []
         }
      },
      //获取能流图列表
      getDeviceList(ids){
          getDeviceByNodeId({"id":ids}).then(res => {
            //  console.log("能流图列表",res);
             if(res.code ==200){
                 
                this.tableData = res.data
                var   a = this.rightData
                    var recursiveFunction = function(){
							const getStr = function(list){
								list.forEach(function(row){
									if(row.ChildDatas.length != 0){
										// console.log("row.ChildDatas",row);
										getStr(row.ChildDatas)
									}else {
                    row.disabled = false
                    res.data.forEach(item => {
                      if(row.Content.Id == item.deviceNo){
                        row.disabled = true
                      }
                    })
 
									}
								})
							}
							getStr(a)
						}
						recursiveFunction()
                // console.log("rightData",this.rightData.filter(item => item.Id == '1'));

             }else {
                this.$message({type: 'warning',message: '获取失败'});
             }
         })
      },
      //弹窗
      popupFn(type){
        if(this.unitItem.length == 0){
             this.$message({type: 'warning',message: '请选择节点'});
             return
        }
            this.dialogVisible = true
         if(type== 'add'){
           this.dialogStatus = "新增"
           this.temp.name = ''
         }else if(type == 'eait'){
            this.dialogStatus = "修改"
            this.temp.name = this.unitItem.unitName

         }
      },
      //添加成功提示
      addSuccess(type){
        if(type == '新增'){
          this.$message({type: 'success',message: '添加成功!'});
        }else {
            this.$message({type: 'success',message: '修改成功!'});
        }
                                 this.findUnitInfoFun()
                                 this.temp.name = ""
                                 this.dialogVisible = false
      },
      //新增修改
      determine_Fn(type){
        //  console.log(this.temp);
        //  console.log(this.radio);
         if(type == '新增'){
            //新增能流图
             if( this.tag ==1){
               var d = {
                          "appType":this.radio,
                          "name":this.temp.name,
                           "unitId":this.unitItem.unitId,
                           "uid": "",
                         }
                        diagramSave(d).then(res => {
                            //  console.log("新增能流图",res);
                           if(res.code == 200){
                              this.addSuccess(type)
                           }else {
                               this.$message({type: 'error',message: '添加失败!'});
                           }
                         })
             }else if( this.tag ==2){
               //新增能流图的节点
                var d = {
                          "flowChartId":this.unitItem.id,
                          "name":this.temp.name,
                           "upId":"",
                           "uid": "",
                         }
                diagramNodeSave(d).then(res => {
                    // console.log("新增能流图的节点",res);
                    if(res.code == 200){
                              this.addSuccess(type)
                              this.nowNode = res.data.id
                              
                     }else {
                               this.$message({type: 'error',message: '添加失败!'});
                           }
                })
             }else if(this.tag >= 3){
                var d = {
                          "flowChartId":this.unitItem.flowChartId,
                          "name":this.temp.name,
                           "upId":this.unitItem.id,
                           "uid": "",
                         }
                diagramNodeSave(d).then(res => {
                    // console.log("新增能流图的节点的子节点",res);
                    if(res.code == 200){
                           this.addSuccess(type)
                           this.nowNode = res.data.id
                     }else {
                               this.$message({type: 'error',message: '添加失败!'});
                           }
                })
             }
           
         }else if(type == '修改'){
            if( this.tag ==2){
               var d = {
                          "appType":this.unitItem.appType,
                          "name":this.temp.name,
                           "unitId":this.unitItem.unitId,
                           "uid": this.unitItem.id,
                         }
                        diagramSave(d).then(res => {
                            //  console.log("修改能流图",res);
                           if(res.code == 200){
                              this.addSuccess(type)
                              this.nowNode = res.data.id
                           }else {
                               this.$message({type: 'error',message: '修改失败!'});
                           }
                         })
             }else if(this.tag >= 3){
                var d = {
                          "flowChartId":this.unitItem.flowChartId,
                          "name":this.temp.name,
                           "upId":this.unitItem.upId,
                           "uid": this.unitItem.id,
                         }
                diagramNodeSave(d).then(res => {
                    // console.log("修改能流图的节点的子节点",res);
                    if(res.code == 200){
                           this.addSuccess(type)
                           this.nowNode = res.data.id
                     }else {
                               this.$message({type: 'error',message: '修改失败!'});
                           }
                })
             }
         }
       
      },
      //删除操作
      delFun(){
        if(this.unitItem.length==0){
            this.$message({type: 'warning',message: '请选择节点'});
             return
        }
         this.$confirm(`是否删除该 ${this.unitItem.unitName}?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
              if(this.tag ==1){
              this.$message({type: 'warning',message: '不可删除单位!'});
            }else if(this.tag ==2){
                diagramDelete({"id":this.unitItem.id}).then(res => {
                    // console.log("删除",res);
                    if(res.code == 200){
                        this.$message({type: 'success',message: '删除成功!'});
                        if(this.nowNode == this.unitItem.id){
                           this.nowNode = ""
                        }
                      this.findUnitInfoFun()
                    }else {
                         this.$message({type: 'error',message: `删除失败! ${res.message}`});
                    }
                })
            }else if(this.tag >=3){
                diagramNodeDelete({"id":this.unitItem.id}).then(res => {
                    // console.log("删除",res);
                     this.findUnitInfoFun()
                       if(res.code == 200){
                        this.$message({type: 'success',message: '删除成功!'});
                         if(this.nowNode == this.unitItem.id){
                           this.nowNode = ""
                        }
                      this.findUnitInfoFun()
                    }else {
                       this.$message({type: 'error',message: `删除失败! ${res.message}`});
                    }
                })
            }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
         
      },
      //移除能流图节点的关联设备
      device_Del(){
        // console.log("this.multipleSelection",this.multipleSelection);
          if( this.multipleSelection.length ==0){
               this.$message({type: 'warning',message: '请勾选需要删除的设备!'});
               return
          }
          var ids = ""
          this.multipleSelection.forEach(item => ids += ','+item.id)
          // console.log(ids.split(1));
          ids = ids.slice(1)
          diagramDeviceDelete(ids).then(res => {
             if(res.code ==200){
               this.$message({type: 'success',message: '移除成功!'});
               this.getDeviceList(this.nodeItem.id)
             }else {
                this.$message({type: 'error',message: `移除失败,${res.message}`});
             }
          })

      },
      //树形结构选中节点
			 currentChecked (nodeObj, SelectedObj) {
            this.checkedNodes = SelectedObj.checkedNodes
              this.checkedNodes =     this.checkedNodes.filter(item => item.Content.Category == 'Device')
            },
      //添加能流图节点的关联设备
      device_Add(){
        //  console.log(this.nodeItem);
          // if(this.tableData.length != 0) {
          //    this.$message({type: 'warning',message: '节点只能绑定一个设备'});
          //    return
          // }
          if(this.nodeItem.length == 0){
             this.$message({type: 'warning',message: '请选择节点!'});
               return
          }
          if( this.checkedNodes.length ==0){
               this.$message({type: 'warning',message: '请勾选需要添加的设备!'});
               return
          }
            var devices = []
           
          this.checkedNodes.forEach(item => {
              devices.push({
                "deviceName":item.Content.Name,
                "deviceNo":item.Content.Id
              })
          })
          var d = {
             	"devices": devices,
                "diagramId": this.nodeItem.flowChartId,
                "nodeId": this.nodeItem.id
          }
          diagramDeviceSave(d).then(res => {
            //  console.log("res添加设备",res);
             if(res.code ==200){
               this.$message({type: 'success',message: '添加成功!'});
                 this.$refs.tree.setCheckedKeys([]);
                 this.getDeviceList(this.nodeItem.id)
             }else {
                this.$message({type: 'error',message: `添加失败! ${res.message}`});
             }
          })

          
          
          // console.log("checkedNodes",this.checkedNodes);
          // console.log("12131",this.nodeItem);
      },
    },
}
</script>

<style lang='scss' scoped>

  /deep/.el-scrollbar .el-scrollbar__wrap {
	overflow-x: hidden;
	}
	/deep/.el-scrollbar__wrap .el-scrollbar__view {
          width: 100%;
  white-space: nowrap;
  display: inline-block;
}
 /deep/.el-dialog{
         width: 25% !important;
      }
   .con {
      width: 100%;
      height: 100%;
      display: flex;
     
      .con-title {
            display: flex;
            align-items: center;
            font-size: 18px;
            margin-left: 10px;
            margin-top: 20px;
            img {
                width: 28px;
                height: 28px;
                margin-right: 10px;
            }
         }
      .tree-left {
         width: 300px;
         height: 100%;
         padding: 12px 12px 12px 12px;
				box-sizing: border-box;
				background-color: #fff;
				margin-right: 8px;
         // background-color: red;
         // text-shadow: 2px 2px 5px red;
        
         .btns {
            display: flex;
            // justify-content: space-evenly;
            margin-bottom: 10px;
            button {
               margin-right: 12px;
            }
             .el-button--mini {
               padding: 6px 10px !important;
            }
            .el-button+.el-button  {
               margin-left: 0px;
            }
         }
         .search {
           margin-bottom: 12px;
           
         }
         
      }
      .content {
         flex: 1;
           border-right: 1px solid #ccc;
           background-color: #fff;
           padding: 12px 20px 20px 20px;
           box-sizing: border-box;
         .content-title {
            
            font-size: 16px;
            color: #999;
         }
         .mytable {
            width: 88%;
            margin-top: 20px;
             /deep/.el-table th {
               background-color: #F1F8FF;
             }
         }
          .conten-btns {
            margin-left: 0.3rem;
        margin-top: 200px;

        // button {
        //    margin-bottom: 20px;
        // }
        div {
          width: 0.88rem;
          height: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          border-radius: 2px;
          background-color: #409EFF;
          color: #fff;
          margin-bottom: 40px;
          cursor: pointer;

          img {
            width: 0.2rem;
            height: 0.2rem;
            margin-left: 0.1rem;
          }
        }

      }
      }
      .tree-right {
        width: 300px;
         height: 100%;
         padding: 12px 12px 12px 12px;
				box-sizing: border-box;
				background-color: #fff;
         .right-tree {
            // margin-top: 20px;
         }
         // background-color: yellow;
      }
   }
</style>